import { Navigate, useLocation } from "react-router-dom";
import { useAuthStore } from "@/store";
import { LoadingLayout } from "@/components/layout/LoadingLayout";

export function ProtectedRoute({ children }) {
  const { status, user, token } = useAuthStore();
  const location = useLocation();

  // If there is no token at all, send user to login
  if (!token) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // While hydrating/auth is in progress, and we still don't have a user, show a loading state
  // (Important: do NOT redirect here, otherwise refresh will always bounce to /home)
  if ((status === "loading" || status === "idle") && !user) {
    return <LoadingLayout />;
  }

  // If we have a token but still no user after hydrate, treat as loading (waiting for hydrate)
  // instead of kicking to login immediately (which causes loops if App.jsx sends them back).
  if (token && !user) {
    return <LoadingLayout />;
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // Render protected content
  return children;
}
